import Model from "../classes/Model";
import Api from "../classes/api/ClientStatus";

export default class ClientStatus extends Model {

    static get STATUS_LID() { return 1; }
    static get STATUS_ACTIVE() { return 2; }
    static get STATUS_EXPIRED() { return 3; }
    static get STATUS_LID_CONTROL() { return 8; }
    static get STATUS_POTENTIAL() { return 7; }
    static get STATUS_REFUSAL() { return 6; }
    static get STATUS_FIRST_TEST() { return 4; }
    static get STATUS_RECORD() { return 5; }

    static get SUB_STATUS_NONE() { return 0; }
    static get SUB_STATUS_LID_ORDERED() { return 1; }
    static get SUB_STATUS_LID_ORDERED_MISS() { return 2; }
    static get SUB_STATUS_LID_CALL_IN_DATE() { return 3; }
    static get SUB_STATUS_LID_CALL_NEVER() { return 4; }
    static get SUB_STATUS_ACTIVE_NEED_CALL() { return 5; }
    static get SUB_STATUS_ACTIVE_CLOSE() { return 6; }
    static get SUB_STATUS_ACTIVE_CLOSE_LESSON() { return 7; }
    static get SUB_STATUS_EXPIRED_BEFORE_2_MONTH() { return 8; }
    static get SUB_STATUS_EXPIRED_BEFORE_6_MONTH() { return 9; }
    static get SUB_STATUS_EXPIRED_BEFORE_12_MONTH() { return 10; }
    static get SUB_STATUS_EXPIRED_AFTER_12_MONTH() { return 11; }

    get id() {
        return this._id;
    }

    set clientId(value) {
        this._clientId = value;
    }
    get clientId() {
        return this._clientId;
    }

    set status(value) {
        this._status = value;
    }
    get status() {
        return this._status;
    }

    set subStatus(value) {
        this._subStatus = value;
    }
    get subStatus() {
        return this._subStatus;
    }

    set statusName(value) {
        this._statusName = value;
    }
    get statusName() {
        return this._statusName;
    }

    set subStatusName(value) {
        this._subStatusName = value;
    }
    get subStatusName() {
        return this._subStatusName;
    }

    get createdAt() {
        return this._createdAt;
    }
    set createdAt(value) {
        this._createdAt = value;
    }

    constructor (config) {
        super();

        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[`_${field}`] = config[field];
        }
    }

    static getStatuses()
    {
        return [
            {id: ClientStatus.STATUS_LID, name: 'Лид'},
            {id: ClientStatus.STATUS_RECORD, name: 'Записан'},
            {id: ClientStatus.STATUS_FIRST_TEST, name: 'Перворазник'},
            {id: ClientStatus.STATUS_ACTIVE, name: 'Активный'},
            {id: ClientStatus.STATUS_EXPIRED, name: 'В оттоке'},
            {id: ClientStatus.STATUS_LID_CONTROL, name: 'Контроль'},
            {id: ClientStatus.STATUS_POTENTIAL, name: 'Потенциал'},
            {id: ClientStatus.STATUS_REFUSAL, name: 'Отказ'},
        ];
    }

    static getSubStatuses()
    {
        return [
            {id: ClientStatus.SUB_STATUS_NONE, name: ''},
            {id: ClientStatus.SUB_STATUS_LID_ORDERED, name: 'Записался'},
            {id: ClientStatus.SUB_STATUS_LID_ORDERED_MISS, name: 'Записался, но не пришел'},
            {id: ClientStatus.SUB_STATUS_LID_CALL_IN_DATE, name: 'Позвонить в заданную дату'},
            {id: ClientStatus.SUB_STATUS_LID_CALL_NEVER, name: 'Больше не звонить'},
            {id: ClientStatus.SUB_STATUS_ACTIVE_NEED_CALL, name: 'Давно не был, позвонить'},
            {id: ClientStatus.SUB_STATUS_ACTIVE_CLOSE, name: 'Абонемент закрыт'},
            {id: ClientStatus.SUB_STATUS_ACTIVE_CLOSE_LESSON, name: 'Абонемент закрыт, но остались занятия'},
            {id: ClientStatus.SUB_STATUS_EXPIRED_BEFORE_2_MONTH, name: 'Отток до 2 месяцев'},
            {id: ClientStatus.SUB_STATUS_EXPIRED_BEFORE_6_MONTH, name: 'Отток до 6 месяцев'},
            {id: ClientStatus.SUB_STATUS_EXPIRED_BEFORE_12_MONTH, name: 'Отток до 12 месяцев'},
            {id: ClientStatus.SUB_STATUS_EXPIRED_AFTER_12_MONTH, name: 'Отток более 12 месяцев'},
        ];
    }

    static toResponse(data) {
        return {
            id: data.id,
            clientId: data.client_id,
            status: data.status,
            subStatus: data.sub_status,
            statusName: data.status_name,
            subStatusName: data.sub_status_name,

            createdAt: data.created_at,
            createdBy: data.created_by,
        };
    }

    static getList(clientId, page, perPage, sort) {
        return Api.getList(clientId, page, perPage, sort).then((response) => {
            let data = [];
            for (let status of response.data) {
                data.push(new this(this.toResponse(status)));
            }
            return {data, headers: response.headers};
        });
    }

}
